<div class="page font-family bodyBackground">
  <div class="modern-header">
    <div class="header-content">
      <mat-icon (click)="goBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
      <h1 class="title">Driving Experience</h1>
    </div>
  </div>
  @if (validationErrorMessage) {
    <div class="validation-error-banner">
      {{ validationErrorMessage }}
    </div>
  }
  <div class="content" [class.has-footer]="showCancelButton">
    <div class="modern-container">
      @if (errorMessage) {
        <mat-error class="error">
          {{ errorMessage }}
        </mat-error>
      }
      <div class="experience-summary-card">
        <h3 class="summary-label">Years of Experience</h3>
        <div class="summary-value">
          @if (noTruckingExperience) {
            <span class="experience-display zero">0</span>
          } @else if (totalYears || totalMonths) {
            <span class="experience-display" [attr.data-testid]="'years-' + totalYears + 'months-' + totalMonths">
              {{ totalYears > 0 ? totalYears + ' Years' : '' }}
              {{ totalMonths > 0 ? totalMonths + ' Months' : '' }}
            </span>
          } @else {
            <span class="no-experience">- -</span>
          }
        </div>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-section">
          <div class="experience-question-card">
            <p class="question-label">Do you have truck driving experience?</p>
            <mat-radio-group class="experience-radio-group"
              [value]="getExperienceRadioValue()"
              (change)="onExperienceRadioChange($event)">
              <mat-radio-button value="yes" data-testid="hasExp-yes">Yes</mat-radio-button>
              <mat-radio-button value="no" data-testid="noExp-no">No</mat-radio-button>
            </mat-radio-group>
          </div>

          @if (!noTruckingExperience && !showCancelButton) {
          <div class="add-new-container">
            <button
              mat-button
              type="button"
              (click)="addDrivingExperienceRecord()"
              data-test="add-truck-experience"
              data-testid="add-truck-experience"
              >
              <i class="material-icons">add</i> Add Truck Driving Experience
            </button>
          </div>
          }

          @if (showCancelButton) {
            <div class="truck-type-question">
              <p class="truck-type-label" data-testid="truck-type-label">What type of truck(s) have you driven?</p>
              <p class="truck-type-hint">Select all that apply and fill in your experience details.</p>
            </div>
            <mat-accordion>
              <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" data-testid="straight-truck-header">
                <mat-expansion-panel-header class="expansion-header">
                  <mat-panel-title class="truck-panel-title" data-test="truck-type">
                    Straight Truck
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-truck-type
                  [group]="form.get('straightTruck')"
                  [groupName]="'straightTruck'"
                  [milesDrivenOptions]="milesDrivenOptions"
                  (yearChange)="onYearChange()"
                  (monthChange)="onMonthChange()"
                  data-testid="straight-truck">
                </app-truck-type>
              </mat-expansion-panel>

              <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" data-testid="tractorSemiTrailer-header">
                <mat-expansion-panel-header class="expansion-header">
                  <mat-panel-title class="truck-panel-title">
                    Tractor and Semi-Trailer
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-truck-type
                  [group]="form.get('tractorAndSemiTrailer')"
                  [groupName]="'tractorAndSemiTrailer'"
                  [milesDrivenOptions]="milesDrivenOptions"
                  (yearChange)="onYearChange()"
                  (monthChange)="onMonthChange()"
                  data-testid="tractor/semi-trailer">
                </app-truck-type>
              </mat-expansion-panel>

              <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" data-testid="tractorTwoTrailers-header">
                <mat-expansion-panel-header class="expansion-header">
                  <mat-panel-title class="truck-panel-title">
                    Tractor-Two Trailers
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-truck-type
                  [group]="form.get('tractorTwoTrailers')"
                  [groupName]="'tractorTwoTrailers'"
                  [milesDrivenOptions]="milesDrivenOptions"
                  (yearChange)="onYearChange()"
                  (monthChange)="onMonthChange()"
                  data-testid="tractor-two trailer">
                </app-truck-type>
              </mat-expansion-panel>

              <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" data-testid="others-header">
                <mat-expansion-panel-header class="expansion-header">
                  <mat-panel-title class="truck-panel-title">
                    Others
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-truck-type
                  [group]="form.get('others')"
                  [groupName]="'others'"
                  [milesDrivenOptions]="milesDrivenOptions"
                  (yearChange)="onYearChange()"
                  (monthChange)="onMonthChange()"
                  data-testid="others">
                </app-truck-type>
              </mat-expansion-panel>
            </mat-accordion>
          }
        </div>
      </form>
    </div>
    <br />
  </div>

  @if (showCancelButton) {
  <div class="fixed-action-footer">
    <button mat-button class="footer-cancel-btn" (click)="cancelAddingExperience()" [disabled]="loading">
      Cancel
    </button>
    <button mat-flat-button class="footer-save-btn" [disabled]="!form.valid || loading" (click)="onSubmit()"
      data-test="save-button" data-testid="saveBtn">
      Save
    </button>
  </div>
  }
</div>
